import { normalizeCandleSymbol } from "../../candle-symbols";
import {
  ExchangeCandleWsAdapter,
} from "../../candle.types";
import { RECONNECT_DELAYS_MS } from "./ws-candle.utils";

interface HyperliquidCandlePayload {
  t: number;
  o: string;
  h: string;
  l: string;
  c: string;
  v?: string;
}

interface HyperliquidWsMessage {
  channel?: string;
  data?: {
    coin?: string;
    interval?: string;
    candle?: HyperliquidCandlePayload;
  };
}

const WS_URL = "wss://api.hyperliquid.xyz/ws";

export const hyperliquidCandlesWsAdapter: ExchangeCandleWsAdapter = {
  subscribe(symbol, interval, onUpdate, onError) {
    const coin = normalizeCandleSymbol("hyperliquid", symbol);
    const normalized = `${coin}USDT`;
    let ws: WebSocket | null = null;
    let attempt = 0;
    let stopped = false;

    const connect = () => {
      if (stopped) return;
      ws = new WebSocket(WS_URL);

      ws.onopen = () => {
        ws?.send(
          JSON.stringify({
            method: "subscribe",
            subscription: {
              type: "candle",
              coin,
              interval,
            },
          })
        );
      };

      ws.onmessage = (event: MessageEvent<string>) => {
        try {
          const message = JSON.parse(event.data) as HyperliquidWsMessage;
          const candle = message.data?.candle;
          if (!candle) return;

          onUpdate({
            symbol: normalized,
            exchange: "hyperliquid",
            interval,
            candle: {
              startTime: Number(candle.t),
              openPrice: candle.o,
              highPrice: candle.h,
              lowPrice: candle.l,
              closePrice: candle.c,
              volume: candle.v ?? "0",
            },
            timestamp: Date.now(),
          });
          attempt = 0;
        } catch {
          // Ignore malformed payloads
        }
      };

      ws.onerror = () => {
        // onclose handles retries
      };

      ws.onclose = () => {
        if (stopped) return;
        const delay =
          RECONNECT_DELAYS_MS[
            Math.min(attempt, RECONNECT_DELAYS_MS.length - 1)
          ];
        attempt += 1;
        if (attempt > RECONNECT_DELAYS_MS.length) {
          onError?.(new Error(`hyperliquid: live candle stream disconnected`));
          return;
        }
        setTimeout(connect, delay);
      };
    };

    connect();
    return () => {
      stopped = true;
      ws?.close();
      ws = null;
    };
  },
};

